import { render, staticRenderFns } from "./TableRiskAppraisal.vue?vue&type=template&id=055a96e0&scoped=true"
import script from "./TableRiskAppraisal.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisal.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisal.vue?vue&type=style&index=0&id=055a96e0&prod&scoped=true&lang=scss"
import style1 from "./TableRiskAppraisal.vue?vue&type=style&index=1&id=055a96e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055a96e0",
  null
  
)

export default component.exports